import { cnpjService, type CnpjResponse } from '@/services';
import { useQuery } from '@tanstack/react-query';

/**
 * Consulta dados de CNPJ via Brasil API (proxy do Portal API).
 *
 * @param cnpj - normalizado (14 caracteres — numérico ou alfanumérico RFB, sem máscara) ou `undefined` para desabilitar
 */
export function useCnpjLookup(cnpj: string | undefined) {
  return useQuery<CnpjResponse | null>({
    queryKey: ['services', 'cnpj', cnpj],
    queryFn: async () => {
      if (!cnpj) return null;

      const response = await cnpjService.getByCnpj(cnpj);

      if (!response.success || !response.data) {
        // Propaga o erro para o componente exibir
        throw new Error(
          response.error ?? 'Erro ao consultar CNPJ',
        );
      }

      return response.data;
    },
    enabled: !!cnpj && cnpj.length === 14,
    retry: false,
    // Brasil API tem rate-limit estreito (~3 req/min por IP). O back-end
    // mantém cache de 24h em sucesso, 10min em 404 e 30s em 429. Aqui no
    // front segurar a query por 1h evita ir ao back para o mesmo CNPJ
    // quando o corretor reabre o form / alterna entre modais.
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
